import { FC } from 'react'
import { AdditionalServicesProtocolAccept } from 'components/AdditionalServices'
import { UserProtectedRoute } from 'routes'

const AdditionalServicesProtocolAcceptPage: FC = () => {
  return (
    <UserProtectedRoute>
      <AdditionalServicesProtocolAccept />
    </UserProtectedRoute>
  )
}

export default AdditionalServicesProtocolAcceptPage
